<div class="gold-coins-page">

  <!-- =====================================================
       SCROLLABLE GOLD COINS CONTENT
  ====================================================== -->
  <div class="gold-coins-scroll">

    <!-- =====================================================
         BUILD COINS SECTION
    ====================================================== -->
    <div
      class="gold-container"
      *ngIf="!showReview">

      <!-- PAGE TITLE -->
      <div class="page-title">

        <div class="back-btnn" (click)="goBack()">
          <img
            class="back"
            src="../../assets/images/back-img.png"
            alt="Back">
        </div>

        <div>
          <h2>
            Build your {{ metalType }} Coin Combination
          </h2>

          <p>
            Minimum order is 100 g
          </p>
        </div>

      </div>


      <!-- =====================================================
           PRICE LOCK BAR
      ====================================================== -->
      <div class="price-lock-bar">

        <div class="lock-info">

          <i class="fas fa-lock"></i>

          <span>
            Price will be locked for :
          </span>

          <strong class="timer-count">
            {{ priceLockTimer }} seconds
          </strong>

        </div>


        <div class="rate-info">

          <span>
            {{ metalType }} Price :
          </span>

          <strong class="rate-value">
            ₹ {{ goldRate | number:'1.2-2' }} / g
          </strong>

        </div>

      </div>


      <!-- =====================================================
           PROGRESS CARD
      ====================================================== -->
      <div class="progress-card">

        <!-- LEFT -->
        <div class="left">

          <span class="label-weight">
            Current weight
          </span>

          <p class="grams-new-weight">
            {{ currentWeight }} g /
            <span class="new-class-span">
              {{ minimumWeight }} g
            </span>
          </p>


          <div class="progress">

            <div
              class="progress-fill"
              [style.width.%]="progressPercentage"
              [ngClass]="
                currentWeight >= minimumWeight
                  ? 'green'
                  : 'yellow'
              ">
            </div>

          </div>

        </div>


        <!-- MIDDLE -->
        <div class="middle">

          <ng-container
            *ngIf="currentWeight < minimumWeight">

            <span class="remaining-weight">
              {{ remainingWeight }} g
            </span>

            <span>
              more required<br>
              to reach minimum
            </span>

          </ng-container>


          <ng-container
            *ngIf="currentWeight >= minimumWeight">

            <h3 class="minimum-reached-weight">
              100 g
            </h3>

            <p>
              Reached minimum
            </p>

          </ng-container>

        </div>


        <!-- RIGHT -->
        <div class="right">

          <img
            [src]="
              metalType === 'Gold'
                ? '../../assets/images/gold-Coins-image.png'
                : '../../assets/images/silver-coin-new.png'
            "
            [alt]="metalType + ' Coins'">

        </div>

      </div>


      <!-- =====================================================
           TABLE HEADER
      ====================================================== -->
      <div class="coin-header">

        <div>
          Coin Size
        </div>

        <div>
          Price (incl. making)
        </div>

        <div>
          Quantity
        </div>

        <div>
          Total Weight
        </div>

      </div>


      <!-- =====================================================
           COIN LIST
      ====================================================== -->
      <div
        class="coin-card"
        *ngFor="let coin of newResCoin">

        <!-- COIN SIZE -->
        <div class="coin-size">

          <img
            [src]="
              metalType === 'Gold'
                ? 'assets/images/Gold-coin.png'
                : 'assets/images/silvercoin.png'
            "
            [alt]="metalType + ' Coin'">

          <span>
            {{ coin.coin_weight }} g
          </span>

        </div>


        <!-- PRICE -->
        <div class="price">

          <h4
            [ngClass]="{
              'price-up': coin.priceTrend === 'up',
              'price-down': coin.priceTrend === 'down'
            }">

            ₹ {{ coin.price | number:'1.2-2' }} / g

          </h4>

          <small>
            Making Charges ₹{{ coin.making_charge }}
          </small>

        </div>


        <!-- QUANTITY -->
        <div class="qty">

          <button
            type="button"
            (click)="decreaseQty(coin)">
            -
          </button>

          <span>
            {{ coin.quantity }}
          </span>

          <button
            type="button"
            (click)="increaseQty(coin)">
            +
          </button>

        </div>


        <!-- WEIGHT -->
        <div class="weight">

          {{ coin.weight * coin.quantity }} g

        </div>

      </div>


      <!-- NO COINS -->
      <div
        *ngIf="!newResCoin || newResCoin.length === 0"
        class="text-center">

        <p class="no-coins-para">
          No Coins Available...
        </p>

      </div>


      <!-- =====================================================
           SELECTION CARD
      ====================================================== -->
      <div class="selection-card">

        <div class="selection-title">
          Your Selection
        </div>


        <div class="selection-items">

          <ng-container
            *ngFor="let coin of selectedCoins">

            <div class="chip">

              {{ coin.weight }} g
              ×
              {{ coin.quantity }}

            </div>

            <span>
              +
            </span>

          </ng-container>

        </div>


        <div class="total-box">

          <span>
            Total weight
          </span>

          <h3>
            {{ currentWeight }} g
          </h3>

        </div>

      </div>


      <!-- WARNING -->
      <p
        class="warning"
        *ngIf="currentWeight < minimumWeight">

        Add {{ remainingWeight }} g more to reach minimum 100 g

      </p>


      <!-- =====================================================
           SUMMARY
      ====================================================== -->
      <div class="summary">

        <!-- TOTAL WEIGHT -->
        <div>

          <small>
            Total Weight
          </small>

          <p class="current-weight-paraa">
            {{ currentWeight }} g /100 g
          </p>

          <span
            [ngClass]="
              currentWeight >= 100
                ? 'green-text'
                : 'red-text'
            ">

            {{
              currentWeight >= 100
                ? 'Minimum order reached'
                : remainingWeight + ' g more required'
            }}

          </span>

        </div>


        <!-- MAKING CHARGES -->
        <div>

          <small>
            Making Charges
          </small>

          <p class="current-weight-paraa">
            ₹{{ makingChargeTotal | number }}
          </p>

        </div>


        <!-- METAL RATE -->
        <div>

          <small>
            {{ metalType }} Rate
          </small>

          <p class="current-weight-paraa">
            ₹{{ goldRate | number:'1.2-2' }} / g
          </p>

        </div>


        <!-- ESTIMATED TOTAL -->
        <div>

          <small>
            Estimated Total
          </small>

          <p class="current-weight-paraa-orange">
            ₹{{ getGrandTotal() | number:'1.2-2' }}
          </p>

        </div>

      </div>


      <!-- CONTINUE -->
      <button
        type="button"
        class="continue-btn"
        [ngClass]="{
          'invalid-weight-btn': !isValidWeight()
        }"
        (click)="continueReview()">

        Continue to review

      </button>

    </div>


    <!-- =====================================================
         REVIEW SECTION
    ====================================================== -->
    <div
      *ngIf="showReview"
      class="review-container">

      <!-- REVIEW HEADER -->
      <div class="review-header">

        <div
          class="review-back"
          (click)="backToSelection()">

          <img
            src="../../assets/images/back-img.png"
            alt="Back">

        </div>


        <div>

          <h2>
            Review Your {{ metalType }} Order
          </h2>

          <p>
            Please verify your selection before proceeding
          </p>

        </div>

      </div>


      <!-- =====================================================
           REVIEW TABLE
      ====================================================== -->
<div class="card">

  <div class="table-header">

    <div>
      Coin Size
    </div>

    <div>
      Price
    </div>

    <div>
      Quantity
    </div>

    <div>
      Total Weight
    </div>

    <div>
      Total Amount
    </div>

  </div>


  <div
    class="table-row"
    *ngFor="let item of selectedCoins">

    <!-- COIN -->
    <div class="coin" data-label="Coin Size">

      <img
        [src]="
          metalType === 'Gold'
            ? 'assets/images/Gold-coin.png'
            : 'assets/images/silvercoin.png'
        "
        [alt]="metalType + ' Coin'">

      <span>
        {{ item.weight }} g
      </span>

    </div>


    <!-- PRICE -->
    <div data-label="Price">
      <span class="row-value">₹{{ item.price | number:'1.2-2' }}</span>
    </div>


    <!-- QUANTITY -->
    <div data-label="Quantity">
      <span class="row-value">{{ item.quantity }}</span>
    </div>


    <!-- TOTAL WEIGHT -->
    <div data-label="Total Weight">
      <span class="row-value">{{ item.weight * item.quantity }} g</span>
    </div>


    <!-- TOTAL AMOUNT -->
    <div data-label="Total Amount">
      <span class="row-value">₹{{ item.price * item.quantity | number:'1.2-2' }}</span>
    </div>

  </div>

</div>


      <!-- =====================================================
           ORDER SUMMARY
      ====================================================== -->
      <div class="summary-card">

        <p class="order-summary">
          Order Summary
        </p>

        <hr>


        <div class="summary-row">

          <span>
            Total Weight
          </span>

          <span>
            {{ currentWeight }} g
          </span>

        </div>


        <div class="summary-row">

          <span>
            {{ metalType }} Amount
          </span>

          <span>
            ₹{{ estimatedTotal | number }}
          </span>

        </div>


        <div class="summary-row">

          <span>
            Making Charges
          </span>

          <span>
            ₹{{ makingChargeTotal | number }}
          </span>

        </div>


        <div class="summary-row">

          <span>
            Delivery Charges
          </span>

          <span class="free">
            FREE
          </span>

        </div>


        <hr>


        <div class="summary-row grand">

          <span>
            Grand Total
          </span>

          <span>
            ₹{{ getGrandTotal() | number:'1.2-2' }}
          </span>

        </div>

      </div>


      <!-- SECURE PAYMENT -->
      <div class="gala-div">

        <img
          class="gala-img"
          src="../../assets/images/gala_secure.png"
          alt="Secure">

        <span class="new-span-paraa">
          100% Secure &amp; Encrypted Payments
        </span>

      </div>


      <!-- BUTTON -->
      <div class="buttons">

        <button
          type="button"
          class="place-btn"
          (click)="placeOrder()">

          Proceed to Payment

        </button>

      </div>


      <!-- SPINNER -->
      <ngx-spinner
        bdColor="rgba(0,0,0,0.5)"
        size="medium"
        color="#d4af37"
        type="ball-spin-clockwise"
        [fullScreen]="true">
      </ngx-spinner>

    </div>

  </div>


  <!-- =====================================================
       MOBILE FOOTER
       ONLY FOR MOBILEVIEW
  ====================================================== -->
  <!-- <div
    class="gold-coins-mobile-footer"
    *ngIf="fromPage === 'mobileview'">

    <app-footermobile></app-footermobile>

  </div> -->

</div>